<template>
	<div class="leftres">
		<div>
			<div :class="showorhide ? 'inputtop' : 'inputtops'">
				<div style="display: inline-block;" v-for="(item, index) of formdata" :key="index">
					<Commondropdownlist ref="invselect" :disabled="item.disabled" :inputflag="item.inputflag"
						:options="item.options" :minrigth="item.minrigth" :maxrigth="item.maxrigth"
						:minleft="item.minleft" :maxleft="item.maxleft" :lablewith="item.lablewith"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :event="item.event" @invClassChage="invClassChage"></Commondropdownlist>
				</div>
				<div :class="showorhide ? 'Btngroups' : 'Btngroup'">
					<CommonBtngroup ref="btngroup" marginRight="40px" :chackbox="true" checktitle="发票待处理"
						:show="showorhide" @showclick="showclick" @hide="hide" @select="select" @reset="reset">
					</CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>

			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Invoicesubmissionmanagementtable ref="invtable" @onRowClick="onRowClick"
					@SaleBillExport="SaleBillExport" :tableData="tableData" :total="total"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Invoicesubmissionmanagementtable>
			</div>
			<div
				style="width: 980px; margin-top: 10px; box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); background-color: #FFFFFF;display: initial;">
				<Invoicesubmissionmanagementbottom :tableDataDetail="tableDataDetail" :tableDataUnique="tableDataUnique"
					:sbmid="sbmid"></Invoicesubmissionmanagementbottom>
			</div>
			<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK"
				:src="'../assets/icon/icon-errors.png'">
				<span
					style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
			</Dialog>

		</div>
	</div>
</template>

<script>
import Commondropdownlist from '../../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../../components/commongroup.vue'
import Dialog from '../../../components/dialog.vue'
import Invoicesubmissionmanagementtable from './components/invoicesubmissionmanagementtable.vue'
import Invoicesubmissionmanagementbottom from './components/invoicesubmissionmanagement-bottom.vue'
import utils from '../../../common/utils'
import {
	SaleBillList,
	SaleBillExport,
	InventoryClassList,
	CusType,
	HelperDPhVoucherType,
	Status,
	SaleBillDetail,
	SaleBillDetailUnique,
	HelperInvoiceChecked,
	GetProvince,
	GetHelperHosGrade
} from '@/api/home'

import {
	HelperLEVEL3
} from '@/api/channel'
export default {
	components: {
		Commondropdownlist,
		CommonBtngroup,
		Dialog,
		Invoicesubmissionmanagementtable,
		Invoicesubmissionmanagementbottom
	},
	data() {
		return {
			total: 1,
			pageindex: 1,
			pageSize: 20,
			tableData: [],
			dialogVisibles: false,
			showorhide: true,
			sbmid: "",
			tableDataDetail: [],
			tableDataUnique: [],
			formdata: [{
				inputdata: '',
				title: '发票号码',
				fontSize: '14px',
				color: '#333333',
				placeholder: '请输入',
				types: 'text',
				inputtype: 'input',
				width: '210px',
				lablewith: '95px'
			},
			{
				inputdata: '',
				title: '发票检验状态',
				fontSize: '14px',
				color: '#333333',
				placeholder: '全部',
				types: '',
				inputtype: 'selectMultiple',
				width: '210px',
				lablewith: '105px',
				options: [

				]
			},
			{
				inputdata: '',
				title: '付款方名称',
				fontSize: '14px',
				color: '#333333',
				placeholder: '请输入',
				types: 'text',
				inputtype: 'input',
				width: '210px',
				disabled: false,
				lablewith: '95px'
			},

			{
				inputdata: '',
				title: '创建公司',
				fontSize: '14px',
				color: '#333333',
				placeholder: '请输入',
				types: 'text',
				inputtype: 'input',
				width: '210px',
				lablewith: '100px',
				disabled: false,
			},
			{
				inputdata: '',
				title: '开票金额',
				fontSize: '14px',
				color: '#333333',
				placeholder: '请输入',
				types: '',
				inputtype: 'numbers',
				width: '74px',
				lablewith: '95px',
				minleft: 0,
				// maxleft: 100,
				minrigth: 0,
				// maxrigth: 100
			},
			{
				inputdata: '',
				title: "录入时间",
				fontSize: "14px",
				color: "#333333",
				placeholder: "请输入",
				types: "",
				inputtype: "date",
				width: "140px",
				lablewith: '155px'
			},
			{
				inputdata: '',
				title: "开票日期",
				fontSize: "14px",
				color: "#333333",
				placeholder: "请输入",
				types: "",
				inputtype: "date",
				width: "130px",
				lablewith: '230px'
			},
			{
				inputdata: '',
				title: '产品型号/名称',
				fontSize: '14px',
				color: '#333333',
				placeholder: '请输入',
				types: 'text',
				inputtype: 'input',
				width: '210px',
				lablewith: '95px'
			},
			{
				inputdata: '',
				title: "审核日期",
				fontSize: "14px",
				color: "#333333",
				placeholder: "请输入",
				types: "",
				inputtype: "date",
				width: "140px",
				lablewith: '100px'
			},
			{
				inputdata: '',
				title: '出库单号',
				fontSize: '14px',
				color: '#333333',
				placeholder: '请输入',
				types: 'text',
				inputtype: 'input',
				width: '300px',
				lablewith: '240px'
			},
			{
				inputdata: '',
				title: '发票方向',
				fontSize: '14px',
				color: '#333333',
				placeholder: '全部',
				types: '',
				inputtype: 'select',
				width: '220px',
				lablewith: '95px',
				options: [{
					value: '蓝票',
					key: '0'
				}, {
					value: '红票',
					key: '1'
				}]
			},
			{
				inputdata: '',
				title: '产品线',
				fontSize: '14px',
				color: '#333333',
				placeholder: '全部',
				types: '',
				inputtype: 'select',
				width: '310px',
				lablewith: '105px',
				options: [

				],
				event: 'invClassChage'
			},
			{
				inputdata: '',
				title: '终端医院',
				fontSize: '14px',
				color: '#333333',
				placeholder: '请输入',
				types: 'text',
				inputtype: 'input',
				width: '300px',
				lablewith: '240px'
			}
			],
			fromdatalist: [],
			from: {
				invoiceNo: '',
				invoiceChecked: '',
				sbDate1: '',
				sbDate2: '',
				salerName: '',
				total1: '',
				total2: '',
				createTime1: '',
				createTime2: '',
				buyerName: '',
				inventory: '',
				verifyTime1: '',
				verifyTime2: '',
				vouCode: '',
				returnFlag: '',
				invClass: '',
				CusTypeFlogs: '',
				TerminalHPName: '',
				ProvinceIDs: '',
				HosGrade: '',
				LEVEL3: '',
				UnDealWith: ''
			}
		}
	},
	mounted() {
		this.inventoryClassList()
		this.helperInvoiceChecked()
		this.CusType()
		// 首页预警处理跳转操作
		let index = window.location.hash.lastIndexOf("?")
		let par = window.location.hash.substring(index + 1, window.location.hash.length);
		let InvoiceNo = par.substring(par.lastIndexOf("=") + 1, par.length);
		let Invoflag = par.substring(20, par.lastIndexOf("="));
		if (Invoflag == "InvoiceNo") {
			this.formdata[0].inputdata = InvoiceNo
			this.from.invoiceNo = InvoiceNo
			this.saleBillList()
			return
		}
		this.saleBillList()
	},
	methods: {
		//省份列表
		async getProvince() {
			let {
				data,
				code,
				message
			} = await GetProvince({})
			console.log(data, '省');
			if (code == 0) {
				this.formdata[13].options = []
				data.map((item, index) => {
					let obj = {
						key: item.Value,
						value: item.Text
					}
					this.formdata[13].options.push(obj)
				})

			} else {
				this.$message({
					type: 'error',
					message: "省份列表加载失败"
				})
			}
		},
		//医院等级
		async getHelperHosGrade(idx = 13) {
			let {
				data,
				code,
				message
			} = await GetHelperHosGrade({})
			if (code == 0) {
				this.formdata[idx].options = []
				data.map((item, index) => {
					let obj = {
						key: item.Value,
						value: item.Text
					}
					this.formdata[idx].options.push(obj)
				})
			} else {
				this.$message({
					type: 'error',
					message: message
				})
			}
		},
		// 列表
		async saleBillList() {
			const loading = this.$loading({
				lock: true,
				text: '正在加载列表...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			setTimeout(() => {
				this.$refs.invtable.$refs.refTableCenter.$refs.fileTableSelect.clearSelection()
			}, 100)
			let {
				data,
				code,
				message
			} = await SaleBillList({
				invoiceNo: this.from.invoiceNo,
				invoiceChecked: this.from.invoiceChecked,
				sbDate1: this.from.sbDate1,
				sbDate2: this.from.sbDate2,
				salerName: this.from.salerName,
				total1: this.from.total1,
				total2: this.from.total2,
				createTime1: this.from.createTime1,
				createTime2: this.from.createTime2,
				buyerName: this.from.buyerName,
				inventory: this.from.inventory,
				verifyTime1: this.from.verifyTime1,
				verifyTime2: this.from.verifyTime2,
				vouCode: this.from.vouCode,
				returnFlag: this.from.returnFlag,
				invClass: this.from.invClass,
				TerminalHPName: this.from.TerminalHPName,
				ProvinceIDs: this.from.ProvinceIDs,
				HosGrade: this.from.HosGrade,
				LEVEL3: this.from.LEVEL3,
				UnDealWith: this.from.UnDealWith,
				pageSize: this.pageSize,
				pageIndex: this.pageindex
			})
			if (code == 0) {
				this.total = data.Count
				this.tableData = data.data
			} else {
				this.$message.warning(message)
			}
			loading.close();
		},
		// 产品线下拉
		async inventoryClassList() {
			let {
				code,
				data
			} = await InventoryClassList({

			})
			if (code == 0) {
				this.formdata[11].options = []
				data.data.map((item, index) => {
					let obj = {
						key: item.InvClass,
						value: item.InvClassName
					}
					this.formdata[11].options.push(obj)
				})
			}
		},
		// 导出
		async SaleBillExport() {
			let resexprot = await SaleBillExport({
				invoiceNo: this.from.invoiceNo,
				invoiceChecked: this.from.invoiceChecked,
				sbDate1: this.from.sbDate1,
				sbDate2: this.from.sbDate2,
				salerName: this.from.salerName,
				total1: this.from.total1,
				total2: this.from.total2,
				createTime1: this.from.createTime1,
				createTime2: this.from.createTime2,
				buyerName: this.from.buyerName,
				inventory: this.from.inventory,
				verifyTime1: this.from.verifyTime1,
				verifyTime2: this.from.verifyTime2,
				vouCode: this.from.vouCode,
				returnFlag: this.from.returnFlag,
				invClass: this.from.invClass,
				TerminalHPName: this.from.TerminalHPName,
				ProvinceIDs: this.from.ProvinceIDs,
				HosGrade: this.from.HosGrade,
				LEVEL3: this.from.LEVEL3,
				UnDealWith: this.from.UnDealWith,
				pageSize: this.pageSize,
				pageIndex: this.pageindex
			})
			let date = new Date()
			let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
			if (resexprot) {
				utils.downloadFile(resexprot.data, `发票管理${str}`, "xlsx")
			} else {
				// 返回json
				this.$message.warning('导出失败');
			}
		},
		async helperInvoiceChecked() {
			let {
				code,
				data
			} = await HelperInvoiceChecked({})
			if (code == 0) {
				this.formdata[1].options = []
				data.map((item, index) => {
					let obj = {
						key: item.Value,
						value: item.Text
					}
					this.formdata[1].options.push(obj)
				})
			}
		},
		// 判断修改是否可用
		async CusType() {
			let {
				data,
				code
			} = await CusType({})
			if (code == 0) {
				// this.CusTypeState = data.CusType
				if (data.CusType == "") {
					this.formdata[3].disabled = false
					this.CusTypeFlogs = 0
				} else if (data.CusType == "平台") {
					this.formdata[3].disabled = true
					this.CusTypeFlogs = 1
				} else if (data.CusType == "经销商") {
					this.formdata[3].disabled = true
					this.CusTypeFlogs = 2
				}
				//this.CusTypeFlogs = 2;
				if (!this.CusTypeFlogs) {
					this.formdata.push({
						inputdata: '',
						title: '省份',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'selectMultiple',
						width: '210px',
						options: [],
						lablewith: '100px'
					}, {
						inputdata: '',
						title: '医院等级',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '210px',
						options: [],
						lablewith: '110px'
					}, {
						inputdata: '',
						title: 'LEVEL3',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '210px',
						options: [],
						lablewith: '110px'
					})
					this.getProvince();
					this.getHelperHosGrade(14);
					this.getHelperLevel3(15);
				} else {
					this.formdata.push({
						inputdata: '',
						title: '医院等级',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '210px',
						options: [],
						lablewith: '110px'
					}, {
						inputdata: '',
						title: 'LEVEL3',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '210px',
						options: [],
						lablewith: '110px'
					})
					this.getHelperHosGrade();
					this.getHelperLevel3();
				}
			}
		},
		//level3
		async getHelperLevel3(idx = 14, invClass = '') {
			let {
				data,
				code
			} = await HelperLEVEL3({
				InvClass: invClass
			})
			if (code == 0) {
				this.formdata[idx].options = []
				data.map((item, index) => {
					let obj = {
						key: item.key,
						value: item.value
					}
					this.formdata[idx].options.push(obj)
				})
			}
		},
		invClassChage(e) {
			let idx = !this.CusTypeFlogs ? 15 : 14;
			this.getHelperLevel3(idx, e.modelvalue);
		},
		reset() {
			for (let index in this.$refs.invselect) {
				if (index == 6 || index == 5 || index == 8) {
					this.$refs.invselect[index].startTime = ''
					this.$refs.invselect[index].endTime = ''
				} else if (index == 4) {
					this.$refs.invselect[index].modelvalueleft = undefined
					this.$refs.invselect[index].modelvalueright = undefined
				} else {
					this.$refs.invselect[index].modelvalue = ''
				}
			}
			this.$refs.btngroup.checkeds = false
		},
		cancel() {
			this.dialogVisibles = false
		},
		dialogOK() {
			this.dialogVisibles = false
		},
		select() {
			for (let item of this.formdata) {
				this.fromdatalist.push(item.inputdata)
			}
			this.pageindex = 1
			// 页码重置为1
			try {
				this.from.invoiceNo = this.$refs.invselect[0].modelvalue
				this.from.invoiceChecked = this.$refs.invselect[1].modelvalue.length ? this.$refs.invselect[1]
					.modelvalue.join(',') : ''
				this.from.sbDate1 = this.$refs.invselect[6].startTime
				this.from.sbDate2 = this.$refs.invselect[6].endTime
				this.from.salerName = this.$refs.invselect[3].modelvalue
				this.from.total1 = this.$refs.invselect[4].modelvalueleft
				this.from.total2 = this.$refs.invselect[4].modelvalueright
				this.from.createTime1 = this.$refs.invselect[5].startTime
				this.from.createTime2 = this.$refs.invselect[5].endTime
				this.from.buyerName = this.$refs.invselect[2].modelvalue
				this.from.inventory = this.$refs.invselect[7].modelvalue
				this.from.verifyTime1 = this.$refs.invselect[8].startTime
				this.from.verifyTime2 = this.$refs.invselect[8].endTime
				this.from.vouCode = this.$refs.invselect[9].modelvalue
				this.from.returnFlag = this.$refs.invselect[10].modelvalue
				this.from.invClass = this.$refs.invselect[11].modelvalue
				this.from.TerminalHPName = this.$refs.invselect[12].modelvalue
				if (!this.CusTypeFlogs) {
					this.from.ProvinceIDs = this.$refs.invselect[13].modelvalue.length ? this.$refs.invselect[13]
						.modelvalue.join(',') : ''
					this.from.HosGrade = this.$refs.invselect[14].modelvalue;
					this.from.LEVEL3 = this.$refs.invselect[15].modelvalue;
				} else {
					this.from.HosGrade = this.$refs.invselect[13].modelvalue;
					this.from.LEVEL3 = this.$refs.invselect[14].modelvalue;
				}
				this.from.UnDealWith = this.$refs.btngroup.checkeds ? 1 : ''
				this.saleBillList()
			} catch (error) {
				this.saleBillList()
			}
		},
		// 明细
		async SaleBillDetail() {
			let {
				data,
				code
			} = await SaleBillDetail({
				sbmid: this.sbmid
			})
			if (code == 0) {
				this.tableDataDetail = data
				this.tableDataMD = data
			}
		},
		// 唯一码
		async SaleBillDetailUnique() {
			let {
				data,
				code,
				message
			} = await SaleBillDetailUnique({
				sbmid: this.sbmid
			})
			if (code == 0) {
				this.tableDataUnique = data
				this.tableDataMD = data
			} else if (code == 101) {
				this.$message({
					type: 'warning',
					message: message
				});
			} else {
				this.$message({
					type: 'error',
					message: message
				});
			}
		},
		onRowClick(val) {
			this.sbmid = val.SBMID
			this.SaleBillDetail()
			this.SaleBillDetailUnique()
		},
		DespatchExport() {

		},
		hide() {
			this.showorhide = false
		},
		showclick() {
			this.showorhide = true
		},
		handleCurrentChange(pageindex) {
			this.pageindex = pageindex
			this.saleBillList()
		},
		handleSizeChange(paegSzie) {
			this.pageSize = paegSzie
			this.saleBillList()
		},
	},
	watch: {
		$route: {
			handler(to, from) {
				// 首页预警处理跳转操作
				let InvoiceNo = to.query.InvoiceNo
				if (InvoiceNo) {
					//console.log(to, '发票TOOOOOO');
					this.formdata[0].inputdata = InvoiceNo
					this.from.invoiceNo = InvoiceNo
					this.saleBillList()
					return
				}
				this.saleBillList()
			},
			deep: true,
			immediate: true
		}
	},
}
</script>

<style lang="less" scoped>
.inputtop {
	width: 980px;
	height: 240px;
	box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
	background-color: #ffffff;
	padding-top: 15px;
	padding-bottom: 70px;
	transition: all 0.3s;
	overflow: hidden;
	position: relative;
}

.inputtops {
	width: 980px;
	height: 0px;
	box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
	background-color: #ffffff;
	padding-top: 9px;
	padding-bottom: 64px;
	overflow: hidden;
	position: relative;
	transition: all 0.3s;
}

.Btngroup {
	display: inline-block;
	float: right;
	margin-right: 10px;
	width: 350px;
	height: 50px;
	background-color: #ffffff;
	position: relative;
	bottom: 190px;
}

.Btngroups {
	display: inline-block;
	float: right;
	margin-top: 50px;
	margin-right: 40px;
}
</style>